import { render, staticRenderFns } from "./CarouselElement.vue?vue&type=template&id=0ee75710&"
import script from "./CarouselElement.vue?vue&type=script&lang=js&"
export * from "./CarouselElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports